import * as React from 'react';
import { Avatar } from '../avatar/avatar';

import './user.scss';

export const User = () => {
    // const { name } = props;
    return (
        <div className="user">
            <div className="spacing"></div>
            <div className="box">
                <h2>Uurtsaikh Batbileg</h2>
                <h3 className="mt1">Software Engineer</h3>
                <p className="mt1">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Aliquid at ipsam reprehenderit maxime a voluptas, dolorum ea
                    qui sed enim.
                </p>
            </div>
            <span className="user-avatar">
                <Avatar size="large" src="https://i.pravatar.cc/150?img=2" />
            </span>
        </div>
    );
};

User.defaultProps = {
    name: 'Uurtsaikh Batbileg'
};
export default User;
